module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "info-widget",
    style: ({
      backgroundColor: _vm.backgroundColor,
      color: _vm.color
    }),
    on: {
      "click": function($event) {
        return _vm.$emit('clicked')
      }
    }
  }, [_c('h3', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (!_vm.animate) ? _c('h4', {
    domProps: {
      "textContent": _vm._s(_vm.stat)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.animate) ? _c('h4', {
    staticClass: "animated bounceIn"
  }, [_c('count-up', {
    attrs: {
      "start": 0,
      "end": _vm.stat,
      "decimals": 0,
      "duration": 2.5,
      "options": _vm.options
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-widget-pic"
  }, [(_vm.showLogo) ? _c('i', {
    class: _vm.logo
  }) : _vm._e(), _vm._v(" "), (_vm.showImage) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b44141"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/InfoWidget.vue
// module id = 2212
// module chunks = 1